import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <defs>
      <path
        id="path-icon-attempts-on-target"
        d="M9 0a9 9 0 110 18A9 9 0 019 0zm0 1.8c-1.11 0-2.162.251-3.1.7l-.932 2.734-2.108.004A7.166 7.166 0 001.8 9c0 .689.097 1.355.277 1.986l3.161 2.093-.66 1.603a7.169 7.169 0 005.037 1.492l2.141-1.895 1.01.858a7.212 7.212 0 003.232-4.436l-1.391-2.778 1.31-.926a7.203 7.203 0 00-2.155-3.398l-3.34.001-.412-1.73A7.262 7.262 0 009 1.8zm-.162 3.6l3.27 2.376-1.249 3.844H6.817L5.568 7.776 8.838 5.4z"
      />
    </defs>
    <g fill="none">
      <g transform="translate(5 7)">
        <mask id="mask-icon-attempts-on-target" fill="#fff">
          <use href="#path-icon-attempts-on-target" />
        </mask>
        <use fill="#FFC100" href="#path-icon-attempts-on-target" />
        <g fill="#051045" mask="url(#mask-icon-attempts-on-target)">
          <path d="M-1-1h20v20H-1z" />
        </g>
      </g>
      <circle cx="6" cy="6" r="6" fill="#00D209" transform="translate(18.5 6)" />
      <path stroke="#FFF" d="M22 12l2 2 3-3" />
    </g>
  </svg>
);

const IconAttemptsOnTarget = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconAttemptsOnTarget;
